import { Box, Stack } from "@mui/material";

interface LoaderProps {
    height?: string;
}

export const Loader = (props: LoaderProps) => (
    <Stack
        textAlign={"center"}
        alignItems={"center"}
        justifyContent={"center"}
        height={props.height ? props.height : "100vh"}
    >
        <Box width={"25%"} height={"25%"}>
            <svg width="100%" height="100%" viewBox="0 0 1209 1209" fill="" xmlns="http://www.w3.org/2000/svg">
                <path
                    className="petal petal-1"
                    d="M1209 0C875.148 0 604.5 270.648 604.5 604.5H1209V0Z"
                    fill="#458CCA"
                />
                <path
                    className="petal petal-2"
                    d="M1209 596.649C871.818 596.649 598.49 869.978 598.49 1207.16C935.669 1207.16 1209 933.828 1209 596.649Z"
                    fill="#458CCA"
                />
                <path
                    className="petal petal-3"
                    d="M612.355 0C274.16 0 0 274.16 0 612.355C338.195 612.355 612.262 338.195 612.262 0"
                    fill="#458CCA"
                />
                <path
                    className="petal petal-4"
                    d="M0.0898438 604.5V1209C333.942 1209 604.59 938.352 604.59 604.5H0.0898438Z"
                    fill="#458CCA"
                />
            </svg>
        </Box>
    </Stack>
);
